import React from 'react';
import '../../styles/help.css'; // Reusing the same style file for consistency
import EnableScrollOnPage from '../../Integrations/EnableScroll'; // Import the scroll enabler

const TCSupportPage = () => {
  return (
    <div className="help-container">
      <EnableScrollOnPage />
      <h1>Support for Train Chess</h1>
      <p>
        If you need help with Train Chess, have suggestions, or encounter any issues, feel free to contact us at
        <a href="mailto:contact@trainchess.net"> contact@trainchess.net</a>.
      </p>

      {/* Social Media Section */}
      <section className="contact-section">
        <h2>Stay Connected</h2>
        <ul>
          <li>
            <a href="https://www.instagram.com/train.chess" target="_blank" rel="noopener noreferrer">
              Instagram
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UCO7Guyli8rWF3CqVOIM1nZA" target="_blank" rel="noopener noreferrer">
              YouTube
            </a>
          </li>
          {/* Add other social media platforms if needed */}
        </ul>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <h2>Frequently Asked Questions</h2>

        <div className="faq-item">
          <h3>What is Train Chess?</h3>
          <p>
            Train Chess is a chess training app designed to help players improve through structured practice.
            The app includes tactical puzzles, endgame training, progress tracking, ratings, and training streaks
            to help players build consistent improvement.
          </p>
        </div>

        <div className="faq-item">
          <h3>How does training work in Train Chess?</h3>
          <p>
            Train Chess provides tactical puzzles and endgame training positions. As you solve puzzles,
            the app tracks your rating, progress, and streaks to help guide your training and highlight
            areas for improvement.
          </p>
        </div>

        <div className="faq-item">
          <h3>How do I report a bug or issue?</h3>
          <p>
            If you encounter a problem, please contact us at
            <a href="mailto:contact@trainchess.net"> contact@trainchess.net</a>.
            Be sure to include a detailed description of the issue and any screenshots if applicable.
          </p>
        </div>

        <div className="faq-item">
          <h3>Is Train Chess free to use?</h3>
          <p>
            Yes! Train Chess is free to use. We are continuously improving the app and adding new training
            features to help chess players improve their skills.
          </p>
        </div>
      </section>

      {/* Help Page Link */}
      <section className="further-help">
        <h3>Need More Help?</h3>
        <p>
          Visit our <a href="/help" className="further-help-link">Help Page</a> for additional support and FAQs.
        </p>
      </section>
    </div>
  );
};

export default TCSupportPage;
